<div class="whatsapppAuthentication-container" *ngIf="!showFail">

  <app-button [textButton]="true" [iconName]="'icon-times'" (click)="onClose()" class="time-close"></app-button>

  <img [src]="logo" class="logo" loading="lazy" alt="logo" *ngIf="logo">
  <img src="assets/generalImage/user.svg" class="default-logo" loading="lazy" alt="logo" *ngIf="!logo">

  <ng-template [ngIf]="!WhatsappLoginResponse && !showSuccess">
    <div class="desc">
      <span class="title">{{ modalHeader | translate}}</span>
      <span>{{ modalDesc | translate}}</span>
    </div>

    <div class="login-action-container">
      <app-button [borderButton]="itm.isBorderButton" [blackTextButton]="itm.isBlackTextButton" [iconName]="itm.icon"
        [buttonName]="itm.name" class="{{itm.stylingClass}}" (click)="itm.onClick()"
        *ngFor="let itm of loginMethod"></app-button>
    </div>

    <div class="tnc-container">
      <app-termandprivacypolicy></app-termandprivacypolicy>
    </div>
  </ng-template>

  <ng-template [ngIf]="WhatsappLoginResponse && !showSuccess">
    <div class="desc">
      <span class="title">{{'desc.waiting.for.whatsapp.response' | translate}}</span>
      <span>{{'desc.verifying.your.information.please.wait' | translate}}</span>
      <span>{{'label.access.code' | translate : {code: accessCode } }}</span>
    </div>

    <div class="loader">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <app-button [textButton]="true" [buttonName]="'button.cancel'" class="cancel-btn" (click)="onClose()"></app-button>
  </ng-template>

  <ng-template [ngIf]="showSuccess">
    <div class="success-login-container">
      <span class="title">{{'label.verifying.success' | translate}}</span>
      <span>{{'desc.thank.for.login.may.enjoy.order.now' | translate: {name : name} }}</span>

      <app-button [buttonName]="'button.close'" class="close-btn" (click)="onClickSuccessClose()"></app-button>
    </div>
  </ng-template>
</div>

<div class="whatsapppAuthentication-fail-container" *ngIf="showFail">
  <i class="icon-alert"></i>
  <div class="desc">
    <span class="title">{{'label.verification.failed' | translate}}</span>
    <span>{{'desc.something.went.wrong.while.verifying.info.please.resending' | translate}}</span>
  </div>

  <div class="action-container">
    <app-button [borderButton]="true" [buttonName]="'button.cancel'" class="close-btn" (click)="onClose()"></app-button>
    <app-button [buttonName]="'button.retry'" class="close-btn" (click)="onRetryLogin()"></app-button>
  </div>
</div>